<template>
  <v-list dense nav>
    <router-link :to="{ name: 'Home' }" v-slot="{ href, navigate, isActive }">
      <v-list-item :active="isActive" :href="href" @click="navigate">
        <v-list-item-icon>
          <v-icon>mdi-view-dashboard</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Dashboard</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </router-link>
    <router-link
      v-if="userAuth.isAdmin"
      :to="{ name: 'Users' }"
      v-slot="{ href, navigate, isActive }"
    >
      <v-list-item :active="isActive" :href="href" @click="navigate">
        <v-list-item-icon>
          <v-icon>mdi-account-multiple-minus-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Usuarios</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </router-link>
    <router-link
      :to="{ name: 'History' }"
      v-slot="{ href, navigate, isActive }"
    >
      <v-list-item :active="isActive" :href="href" @click="navigate">
        <v-list-item-icon>
          <v-icon>mdi-history</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Históricos</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </router-link>
    <router-link
      v-if="Config.client == 'DHL'"
      :to="{ name: 'Clients' }"
      v-slot="{ href, navigate, isActive }"
    >
      <v-list-item :active="isActive" :href="href" @click="navigate">
        <v-list-item-icon>
          <v-icon>mdi-account-group</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Clientes</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </router-link>
    <router-link
      v-if="Config.client == 'DHL'"
      :to="{ name: 'Workgroups' }"
      v-slot="{ href, navigate, isActive }"
    >
      <v-list-item :active="isActive" :href="href" @click="navigate">
        <v-list-item-icon>
          <v-icon>mdi-group</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Grupos de trabajo</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </router-link>
    <router-link
      v-if="Config.client == 'DHL'"
      :to="{ name: 'Schedules' }"
      v-slot="{ href, navigate, isActive }"
    >
      <v-list-item :active="isActive" :href="href" @click="navigate">
        <v-list-item-icon>
          <v-icon>mdi-av-timer</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Horarios</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </router-link>
    <router-link
      v-if="Config.client == 'DHL'"
      :to="{ name: 'ClientsWorkgroups' }"
      v-slot="{ href, navigate, isActive }"
    >
      <v-list-item :active="isActive" :href="href" @click="navigate">
        <v-list-item-icon>
          <v-icon>mdi-transit-connection</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Configurar Clientes-Grupos</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </router-link>
  </v-list>
</template>

<script>
import { Config } from "../../config";
export default {
  data: () => ({
    Config: Config,
    userAuth: localStorage.getItem("userAuth")
      ? JSON.parse(localStorage.getItem("userAuth"))
      : null
  })
};
</script>

<style></style>
